<p-dropdown
  [options]="chartTypeOptions"
  [(ngModel)]="chartTypeValue"
  optionLabel="name"
  optionValue="id"
  styleClass="w-[8rem] nem-dropdown-xs">
  <ng-template let-type pTemplate="item">
    <div class="flex gap-2 items-center">
      <span class="text-indigo-600 pi" [ngClass]="type.icon"></span>
      <div>{{ type.name }}</div>
    </div>
  </ng-template>
</p-dropdown>

<p-button
  icon="pi pi-tablet"
  [text]="true"
  [rounded]="true"
  severity="secondary"
  pTooltip="Active focus mode"
  tooltipPosition="top"
  (onClick)="focusModeChange.emit(true)"
  aria-label="Active focus mode view">
</p-button>

<p-button
  icon="pi pi-table"
  [text]="true"
  [rounded]="true"
  severity="secondary"
  pTooltip="Show/Hide tabular view"
  tooltipPosition="top"
  (onClick)="toggleTableViewChange.emit(true)"
  aria-label="toggle tabular view">
</p-button>

<p-button
  icon="pi pi-file-export"
  [text]="true"
  [rounded]="true"
  severity="secondary"
  pTooltip="Export CSV"
  tooltipPosition="top"
  (onClick)="exportToCSVChange.emit(true)"
  aria-label="export button">
</p-button>

<p-button
  icon="pi pi-window-maximize"
  [text]="true"
  [rounded]="true"
  severity="secondary"
  pTooltip="Maximize panel"
  tooltipPosition="top"
  (onClick)="dialogVisibleChange.emit(true)"
  aria-label="expand button">
</p-button>
